import { createApiConstants, createConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'gettingStarted/appUpload';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

const APP_STORAGE_UPLOAD_APP_PREFIX = 'APP_STORAGE_UPLOAD_APP';
export const APP_STORAGE_UPLOAD_APP = Object.freeze({
  ...createApiNamespacedConstants(APP_STORAGE_UPLOAD_APP_PREFIX),
  ...createConstants(NAMESPACE, APP_STORAGE_UPLOAD_APP_PREFIX)('PROGRESS'),
  ...createConstants(NAMESPACE, APP_STORAGE_UPLOAD_APP_PREFIX)('PROCESSING'),
});
